module.exports = __webpack_public_path__ + "static/sport/bgi-pc.8353401.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/road/bgi-pc.jpg
// module id = ss9A
// module chunks = 0